"use client"

import { useLanguage } from "@/core/context/language-provider"
import { getServiceData, getSubServiceData, getAllSubServicesForCategory } from "@/data/services"

export function useServiceLanguage() {
  const { language } = useLanguage()

  return {
    getServiceData: (category: string) => getServiceData(category, language),
    getSubServiceData: (category: string, subServiceId: string) => getSubServiceData(category, subServiceId, language),
    getAllSubServicesForCategory: (category: string) => getAllSubServicesForCategory(category, language),
  }
}

